module.exports = __webpack_public_path__ + "static/herobgmd-8781d1f540e7851899872e67ca39fa6e.png";